import { render, staticRenderFns } from "./VisualRecognitionListView.vue?vue&type=template&id=071acb76&"
import script from "./VisualRecognitionListView.vue?vue&type=script&lang=js&"
export * from "./VisualRecognitionListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports